import { useMutation } from 'react-query';
import client from './client';
import { toast } from 'react-toastify';
import {
  PBMVerifyInput,
  PBMVerifyResponse,
  PBMVerifyPricesInput,
  PBMVerifyPricesResponse,
  CartVerifyInput,
  CartVerifyItemResponse,
  PBMActivateInput,
} from '@/types';

export const usePBMVerify = () => {
  return useMutation<PBMVerifyResponse, Error, PBMVerifyInput>(
    client.pbm.verify,
    {
      onError: (error) => {
        const {
          response: { data },
        }: any = error ?? {};

        toast.error(data?.message || 'Erro ao verificar CPF');
      },
    },
  );
};

export const usePBMActivate = () => {
  return useMutation<PBMVerifyResponse, Error, PBMActivateInput>(
    client.pbm.activate,
    {
      onError: (error: any) => {
        const data = error?.response?.data;
        toast.error(
          data?.message || 'Erro ao concluir adesão ao programa laboratorial',
        );
      },
    },
  );
};

export const usePBMVerifyPrices = () => {
  return useMutation<PBMVerifyPricesResponse, Error, PBMVerifyPricesInput>(
    client.pbm.verifyPrices,
    {
      onError: (error: any) => {
        const data = error?.response?.data;
        toast.error(data?.message || 'Erro ao verificar preços PBM');
      },
    },
  );
};

export const useCartVerify = () => {
  return useMutation<CartVerifyItemResponse[], Error, CartVerifyInput>(
    client.pbm.cartVerify,
  );
};
